import padStart from 'lodash/padStart';

export interface IMaskFunction {
  apply: (value: number | string) => string;
  clean: (value: string) => number;
}

export const newMoneyWithNegative : IMaskFunction = {
  apply: (value: number | string): string => {
    if (value === null || value === undefined || value === '') return '0,00';
    const numberValue = Number(value);
    const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    const parts = formatter.formatToParts(numberValue || 0);
    let newValue = '0,00';
    const isNegative = numberValue < 0;

    if (parts.length === 6 && isNegative) newValue = `-${parts[3].value}${parts[4].value}${parts[5].value}`;
    else if (parts.length === 5 && !isNegative) newValue = `${parts[2].value}${parts[3].value}${parts[4].value}`;
    else if (parts.length === 8 && isNegative) newValue = `-${parts[3].value}${parts[4].value}${parts[5].value}${parts[6].value}${parts[7].value}`; // e.g., -R$ 12,34
    else if (parts.length === 7 && !isNegative) newValue = `${parts[2].value}${parts[3].value}${parts[4].value}${parts[5].value}${parts[6].value}`; // e.g., R$ 12,34
    else if (parts.length === 10 && isNegative) newValue = `-${parts[3].value}${parts[4].value}${parts[5].value}${parts[6].value}${parts[7].value}${parts[8].value}${parts[9].value}`; // e.g., -R$ 123,45
    else if (parts.length === 9 && !isNegative) newValue = `${parts[2].value}${parts[3].value}${parts[4].value}${parts[5].value}${parts[6].value}${parts[7].value}${parts[8].value}`; // e.g., R$ 123,45

    return newValue;
  },
  clean: (value: string): number => {
    value = (value || '').toString().replace(/[^\d,-]/gi, '');

    const isNegative = value.startsWith('-');
    if (isNegative) {
      value = value.slice(1);
    }

    if (!value.includes(',')) {
      value = '0,' + padStart(value, 2, '0');
    }

    const [, cents] = value.split(',');
    if (cents && cents.length !== 2) {
      value = value
        .replace(',', '')
        .replace(/(\d+)?(\d{2})/gi, '$1,$2')
        .replace(/^,/gi, '0,');
    }

    const result = parseFloat(value.replace(/\./gi, '').replace(',', '.'));
    return isNegative ? -result : result;
  }
};

export const newMoney: IMaskFunction = {
  apply: (value: number | string): string => {
    if (value === null || value === undefined || value === '') return '0,00';
    const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    const parts = formatter.formatToParts(Number(value) || 0);
    let newValue = '0,00';
    if (parts.length === 5) newValue = `${parts[2].value}${parts[3].value}${parts[4].value}`;
    if (parts.length === 7) newValue = `${parts[2].value}${parts[3].value}${parts[4].value}${parts[5].value}${parts[6].value}`;
    if (parts.length === 9) newValue = `${parts[2].value}${parts[3].value}${parts[4].value}${parts[5].value}${parts[6].value}${parts[7].value}${parts[8].value}`;
    return newValue;
  },
  clean: value => {
    value = (value || '').toString().replace(/[^\d,]/gi, '');

    if (!value.includes(',')) {
      value = '0,' + padStart(value, 2, '0');
    }

    const [, cents] = value.split(',');
    if (cents && cents.length !== 2) {
      value = value
        .replace(',', '')
        .replace(/(\d+)?(\d{2})/gi, '$1,$2')
        .replace(/^,/gi, '0,');
    }

    return parseFloat(value.replace(/\./gi, '').replace(',', '.'));
  }
};

